import { render, staticRenderFns } from "./Externa.vue?vue&type=template&id=89b4b98c"
import script from "./Externa.vue?vue&type=script&lang=js"
export * from "./Externa.vue?vue&type=script&lang=js"
import style0 from "./Externa.vue?vue&type=style&index=0&id=89b4b98c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports